// Only the product's words (productBrand), unchanged: the Control Board sign-in already names Rithmo, never a customer.
export const productBrand = {
  company: 'Rithmo',
  product: 'Control Board',
  signInTitle: 'Sign in to Rithmo',
  signInSubtitle: 'Your organization\'s Control Board: what is verified, what is changing, and whether your agents are ready.',
  signInHeadline: 'Know what your agents rely on.',
  signInLede: 'The verified business context, who may change it, every change as it develops, and whether each agent action is ready.',
  governedBy: 'Every status here is read from the organization\'s own record.',
}
